import { NgModule } from '@angular/core';
import {FileComponent} from './file-drop.component';

@NgModule({
  declarations: [
    FileComponent,
  ],
  exports: [FileComponent],
  imports: [],
  providers: [],
  bootstrap: [FileComponent],
})
export class FileDropModule {}


// WEBPACK FOOTER //
// /Volumes/MACOS-START/Outside/SITE Co-WORKING/ng/~/ngx-file-drop/lib/ngx-drop/file-drop.module.ts